export enum RequestSource {
  DomesticAndGeneralIE = 'DandGIE',
  DomesticAndGeneralUK = 'DandGUK',
  DomesticAndGeneralUK_Discounted = 'DandGUK_DISC10',
  DomesticAndGeneralUK_ExistingCustomer = 'DandGUK_EXCUST20',
  DomesticAndGeneralUK_HooverCandy = 'DandGUK_HCAPP',
  DomesticAndGeneralUKMultiQuote = 'DandGUKMQ',
}
